import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import _ from 'lodash';
import { Button } from 'ziphy-web-shared/basic/lib/buttons';
import { useForm } from 'ziphy-web-shared/basic/lib/forms';
import { $windowSize } from 'ziphy-web-shared/basic/utils';
import { $router } from 'ziphy-web-shared/basic/utils/router';
import Toolbar from '@core/src/nedoShared/features/layouts/toolbar/Toolbar';
import DashboardActivity from '@nedoShared/modules/dashboard/dashboardActivity/DashboardActivity';
import DashboardHeader from '@nedoShared/modules/dashboard/dashboardHeader/DashboardHeader';
import DashboardSidebar from '@nedoShared/modules/dashboard/dashboardSidebar/DashboardSidebar';
import styles from './DashboardPage.module.scss';
const DashboardPage = () => {
    const filters = $router.searchParams.getAll();
    const [showMobileCalendar, setShowMobileCalendar] = useState(false);
    const toggleMobileCalendar = () => setShowMobileCalendar((prev) => !prev);
    const { form, fields, values } = useForm({
        search: { value: String(filters.search || '') },
        dateFrom: { value: filters.dateFrom || '' },
        dateTo: { value: filters.dateTo || '' },
        type: { value: filters.type || 'all' },
    });
    const applyPatch = useCallback((patch) => {
        Object.entries(patch).forEach(([key, value]) => {
            var _a;
            const field = fields[key];
            (_a = field === null || field === void 0 ? void 0 : field.onChange) === null || _a === void 0 ? void 0 : _a.call(field, value);
            if (value == null || value === '') {
                $router.searchParams.remove(key);
            }
            else {
                const v = key === 'statOnly' && typeof value === 'boolean' ? (value ? '1' : '0') : String(value);
                $router.searchParams.set(key, v);
            }
        });
    }, [fields]);
    const handleOnChangeInstant = applyPatch;
    const handleOnChangeFilters = useMemo(() => _.debounce(applyPatch, 400), [applyPatch]);
    useEffect(() => {
        return () => {
            // $router.searchParams.clear()
        };
    }, []);
    return (_jsxs(_Fragment, { children: [$windowSize.isMobile && (_jsx(Toolbar, Object.assign({ hasBurger: true }, { children: _jsx(Button, { mode: ['sm'], onClick: toggleMobileCalendar, leftElement: showMobileCalendar ? 'close' : 'calendar' }) }))), _jsxs("div", Object.assign({ className: styles.content }, { children: [_jsxs("div", Object.assign({ className: styles.contentMain }, { children: [_jsx(DashboardHeader, { onChange: handleOnChangeFilters, field: fields.search }), _jsx(DashboardActivity, { fields: fields, values: values, onChange: handleOnChangeInstant })] })), _jsx("div", Object.assign({ className: classNames(styles.contentSidebar, {
                            [styles.mobileVisible]: showMobileCalendar,
                        }) }, { children: _jsx(DashboardSidebar, {}) }))] }))] }));
};
export default observer(DashboardPage);
